export default {
    '批量添加完成':'批量添加完成',
    '教师导入模板':'教師導入模板',
    '学生导入模板':'學生導入模板',
    '导入中请不要退出当前页面。':'導入中請不要退出當前頁面。',
    '人脸导入{name}':'人臉導入{name}',
    '手机号':'手機號',
    '姓名':'姓名',
    '工号':'工號',
    '只能导入格式为':'只能導入格式為png、jpg、jpeg的文件，文件命名格式為（手機號 或 姓名 或 工號）,單張人臉大小不超過10M',
    '导入成功数量：':'導入成功數量：',
    '导入失败数量：':'導入失敗數量：',
    '点击导入':'點擊導入',
    '导入失败人员列表':'導入失敗人員列表',
    '失败原因':'失敗原因',
    '表格数据':'表格數據',
    '正在准备图片':'正在準備圖片',
    '压缩图片中':'壓縮圖片中',
    '文件超过10MB':'文件超過10MB',
    '图片损坏无法打开':'圖片損壞無法打開',
    '文件格式错误':'文件格式錯誤',
    '数据导入成功，但有失败数据。请点击':'數據導入成功，但有失敗數據。請點擊',
    '教师信息':'教師信息',
    '编辑教职工':'編輯教職工',
    '新增教职工':'新增教職工',
    '请输入用户名称':'請輸入用戶名稱',
    '请输入登录账号':'請輸入登錄賬號',
    '登录账号已存在，请重新输入':'登錄賬號已存在，請重新輸入',
    '登录账号长度最多为20位':'登錄賬號長度最多為20位',
    '登录账号长度至少为6位':'登錄賬號長度至少為6位',
    '请输入有效的账号':'請輸入有效的賬號',
    '请输入登录密码':'請輸入登錄密碼',
    '账号密码格式仅支持大小写字母、数字及特殊符号':'賬號密碼格式僅支持大小寫字母、數字及特殊符號',
    '登录密码长度至少为8位':'登錄密碼長度至少為8位',
    '请选择角色':'請選擇角色',
    '请输入手机号':'請輸入手機號',
    '请输入正确的手机号':'請輸入正確的手機號',
    '请选择性别':'請選擇性別',
    '请输入姓名':'請輸入姓名',
    '正在加载数据，请稍后':'正在加載數據，請稍後...',
    '用户信息':'用戶信息',
    '登录账号':'登錄賬號',
    '请输入6':'請輸入6-20位純數字/字母或者數字+字母組合',
    '登录密码':'登錄密碼',
    '重置密码':'重置密碼',
    '角色':'角色',
    '执教班级':'執教班級',
    '请选择执教班级':'請選擇執教班級',
    '工号':'工號',
    '请输入工号':'請輸入工號',
    'ID卡号':'ID卡號',
    'ID卡号仅支持数字':'ID卡號僅支持數字',
    '请填写ID卡号':'請填寫ID卡號',
    '账户信息':'賬戶信息',
    '账户信息是该账户下所有用户的公用信息':'賬戶信息是該賬戶下所有用戶的公用信息',
    '去认证':'去認證',
    '证件类型':'證件類型',
    '请选择证件类型':'請選擇證件類型',
    '证件号':'證件號',
    '请输入证件号':'請輸入證件號',
    '人脸照片':'人臉照片',
    '认证手机号':'認證手機號',
    '教职工管理':'教職工管理',
    '请输入名称':'請輸入名稱/賬號',
    '批量新增教师':'批量新增教師',
    '批量导出教师':'批量導出教師',
    '批量添加照片':'批量添加照片',
    '批量删除教师':'批量刪除教師',
    '新增教师':'新增教師',
    '批量导入教师人脸':'批量導入教師人臉',
    '是否删除此用户？':'是否刪除此用戶？',
    '删除教师':'刪除教師',
    '请选择教师':'請選擇教師',
    '导入中请不要退出当前页面。':'導入中請不要退出當前頁面。',
    '学籍号人脸导入':'學籍號人臉導入',
    '姓名人脸导入':'姓名人臉導入',
    '只能导入格式为学籍号':'只能導入格式為png、jpg、jpeg的文件，文件命名格式為（學籍號 或 姓名）,單張人臉大小不超過10M',
    '学生信息':'學生信息',
    '编辑学生':'編輯學生',
    '新增学生':'新增學生',
    '请选择班级':'請選擇班級',
    '学籍号已注册':'學籍號已註冊',
    '数据保存成功':'數據保存成功',
    '请填写家长姓名':'請填寫家長姓名',
    '请填写家长性别':'請填寫家長性別',
    '请填写家长关系':'請填寫家長關係',
    '请填写家长联系方式':'請填寫家長聯繫方式',
    '为空则系统自动生成':'若為空則系統自動生成',
    '家长{num}的联系方式格式不正确，请重新填写':'家長{num}的聯繫方式格式不正確，請重新填寫',
    '家长姓名':'家長姓名',
    '家长关系':'家長關係',
    '联系方式':'聯繫方式',
    '家长手机号':'家長手機號碼',
    '学号':'學號',
    '请输入学号':'請輸入學號',
    '请输入学籍号':'請輸入學籍號',
    '民族':'民族',
    '请选择民族':'請選擇民族',
    '家长信息':'家長信息',
    '新增家长':'新增家長',
    '请输入家长姓名':'請輸入家長姓名',
    '请输入家长手机号':'請輸入家長手機號碼',
    '请输入正确的家长手机号':'請輸入正確的家長手機號碼',
    '该学生已存在相同登录账号的家长':'該學生已存在相同登錄賬號的家長',
    '该学生已存在相同手机的家长':'該學生已存在相同手機的家長',
    '确认删除吗':'確認刪除嗎',
    '用户列表':'用戶列表',
    '请输入姓名或账号':'請輸入姓名或賬號',
    '批量删除':'批量刪除',
    '人脸批量导入':'人臉批量導入',
    '批量导入人脸照片':'批量導入人臉照片',
    '关闭后，将中止上传':'關閉後，將中止上傳',
    '已成功的照片不受影响':'已成功的照片不受影響',
    '删除学生':'刪除學生',
    '请选择学生':'請選擇學生',
    '家长信息':'家長信息',
    '编辑家长':'編輯家長',
    '新增家长':'新增家長',
    '子女信息不能为空':'子女信息不能為空',
    '学生姓名':'學生姓名',
    '保存用户成功':'保存用戶成功',
    '子女信息':'子女信息',
    '编辑用户':'編輯用戶',
    '新增用户':'新增用戶',
    '组织结构':'組織結構',
    '请选择组织结构':'請選擇組織結構',
    '请选择院系':'請選擇院系',
    '学籍号已注册':'學籍號已註冊',
    '请输入名称与账号':'請輸入名稱/賬號/手機號/學籍號',
    '批量导入学生':'批量導入學生',
    '批量导出学生':'批量導出學生',
    '批量导出家长':'批量导出家长',
    '批量删除家长':'批次刪除家長',
    '是否停用此用户？':'是否停用此用戶？',
    '删除家长':'刪除家長',
    '请选择家长':'請選擇家長',
    '获取验证码':'獲取驗證碼',
    '请输入手机验证码':'請輸入手機驗證碼',
    '手机验证码':'手機驗證碼',
    '认证':'認證',
    '手机号不能为空！':'手機號不能爲空！',
    '手机验证码不能为空！':'手機驗證碼不能爲空！',
    '账号信息':'賬號信息',
    '请输入姓名，不超过20个字':'請輸入姓名，不超過20個字',
    '编辑角色账号信息':'編輯角色賬號信息',
    '角色账号信息更新成功':'角色賬號信息更新成功',
    '账户信息修改将会影响该账户下所有用户的共有信息。':'賬戶信息修改將會影響該賬戶下所有用戶的共有信息',
    '编辑账户信息':'編輯賬戶信息',
    '账户信息更新成功':'賬戶信息更新成功',
    '用户反馈':'用戶反饋',
    '登录密码不能为空':'登入密碼不能為空！',
    '进入':'進入',

    //25-7-31
    '市民管理':'市民管理',
    '注册场所':'註冊場所',
    '注册时间':'註冊時間',
    '批量新增市民':'批量新增市民',
    '批量导出市民':'批量導出市民',
    '批量删除市民':'批量刪除市民',
    '新增市民':'新增市民',
    '编辑市民':'編輯市民',
    //25-8-1
    '操作成功':'操作成功',
    '用户名称':'用戶名稱',
    '登录账号':'登錄賬號',
    '注册来源':'註冊來源',
    '获取成功':'獲取成功',
    '市民信息':'市民信息',
    '生日':'生日',
    '家庭住址':'家庭住址',
    '学生':'學生',
    '游客':'遊客',
}    
